<script>
  // @ts-check
  import Grid from "../atoms/Grid.svelte";
  import GridContainer from "../atoms/GridContainer.svelte";
  import GridDivider from "../atoms/GridDivider.svelte";
  import ImageContent from "./ImageContent.svelte";

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = undefined;

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Array of images width caption and image url.
   * @type {Array<{caption: string, srcset: string, aspectRatio: string, sizes: string, image: import('../types/shared.js').Image }>}
   */
  export let images = [];
  /**
   * The image variant of ImageGrid (all images will be the same aspect ratio)
   * @type {"portrait" | "landscape" | "square"}
   */
  export let aspectRatio = "landscape";
</script>

<GridContainer {id} gridInnerClasses="relative" containerClass={className}>
  <GridDivider numberOfColumns={2} containerClasses="hidden md:block" />
  <Grid gridClass="gap-y-0 md:gap-y-15 lg:gap-y-20">
    {#each images as { image, caption }}
      <div
        class="col-full-width border-t-thin py-7.5 first-of-type:border-none first-of-type:pt-0 last-of-type:pb-0 md:col-span-6 md:border-none md:py-0"
      >
        <div class="w-full" {id}>
          <ImageContent {image} {aspectRatio} {caption} />
        </div>
      </div>
    {/each}
  </Grid>
</GridContainer>
